import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=59fd473d&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=ts&"
export * from "./Platform.vue?vue&type=script&lang=ts&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=59fd473d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd473d",
  null
  
)

export default component.exports